import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'que-distribution-group-list-header',
    imports: [CommonModule, TranslateDirective, TranslatePipe],
    templateUrl: './distribution-group-list-header.component.html',
    styleUrls: ['./distribution-group-list-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DistributionGroupListHeaderComponent {

}
